module.exports = __webpack_public_path__ + "img/logo.60c3950c.png";